<div *transloco="let t">
	<ng-container class="flex flex-col">
		<div class="flex flex-col">
			<div class="p-2">
				<div style="font-weight: bolder">{{ t('enum.' + deviceType) }} ({{ t('enum.' + deviceType + '_long') }}) Nr. {{ deviceNumber }}</div>
			</div>
			<div class="p-4">
				<div style="font-weight: bold">
					{{ t('readingValueInfo.readValuesTitle') }}
				</div>

				@if (energyBaseCalculation.infoReadingValues.length > 0) {
					@for (infoReadingValue of energyBaseCalculation.infoReadingValues; track infoReadingValue) {
						<div class="flex flex-row justify-between items-start">
							<div>
								{{ dateUtil.setDateFormatByActiveLang(infoReadingValue.readingDate, '') }}
							</div>
							<div>
								{{
									energyBaseCalculation.readingValueDifferenceUnit === PhysicalUnit.UNITS ||
									energyBaseCalculation.readingValueDifferenceUnit === PhysicalUnit.KWH
										? numberUtil.scaleAndReplaceDot(infoReadingValue.value, 0)
										: numberUtil.scaleAndReplaceDot(infoReadingValue.value, 2)
								}}
								{{ t('enum.' + infoReadingValue.unit) }}
							</div>
						</div>
					}
				} @else {
					<p [innerHTML]="t('readingValueInfo.noReadingValues')"></p>
				}
			</div>
			@if (energyBaseCalculation.infoReadingValues.length > 0) {
				<div class="p-4">
					<div style="font-weight: bold">
						{{ t('readingValueInfo.calculatedValuesTitle') }}
					</div>
					<div class="flex flex-row justify-between items-start">
						<div class="flex flex-col">
							<div>
								{{ dateUtil.setDateFormatByActiveLang(energyBaseCalculation.periodBeginEstimatedReadingValue.readingDate, '') }}
							</div>
							<div>
								{{ dateUtil.setDateFormatByActiveLang(energyBaseCalculation.periodEndEstimatedReadingValue.readingDate, '') }}
							</div>
						</div>
						<div style="text-align: right" class="flex flex-col">
							<div>
								{{
									energyBaseCalculation.readingValueDifferenceUnit === PhysicalUnit.UNITS ||
									energyBaseCalculation.readingValueDifferenceUnit === PhysicalUnit.KWH
										? numberUtil.scaleAndReplaceDot(energyBaseCalculation.periodBeginEstimatedReadingValue.value, 0)
										: numberUtil.scaleAndReplaceDot(energyBaseCalculation.periodBeginEstimatedReadingValue.value, 2)
								}}
								{{ t('enum.' + (energyBaseCalculation.periodBeginEstimatedReadingValue.unit ?? 'UNITS')) }}
							</div>
							<div>
								{{
									energyBaseCalculation.readingValueDifferenceUnit === PhysicalUnit.UNITS ||
									energyBaseCalculation.readingValueDifferenceUnit === PhysicalUnit.KWH
										? numberUtil.scaleAndReplaceDot(energyBaseCalculation.periodEndEstimatedReadingValue.value, 0)
										: numberUtil.scaleAndReplaceDot(energyBaseCalculation.periodEndEstimatedReadingValue.value, 2)
								}}
								{{ t('enum.' + (energyBaseCalculation.periodEndEstimatedReadingValue.unit ?? 'UNITS')) }}
							</div>
						</div>
					</div>
				</div>
				<div class="p-4">
					<div style="font-weight: bold">
						{{ t('readingValueInfo.usedConsumptions') }}
					</div>
					<div class="flex flex-row justify-between items-start">
						<div>
							{{ t('readingValueInfo.difference') }}
						</div>
						<div>
							{{
								energyBaseCalculation.readingValueDifferenceUnit === PhysicalUnit.UNITS ||
								energyBaseCalculation.readingValueDifferenceUnit === PhysicalUnit.KWH
									? numberUtil.scaleAndReplaceDot(energyBaseCalculation.readingValueDifference, 0)
									: numberUtil.scaleAndReplaceDot(energyBaseCalculation.readingValueDifference, 2)
							}}
							{{ t('enum.' + (energyBaseCalculation.readingValueDifferenceUnit ?? 'UNITS')) }}
						</div>
					</div>
					@if (energyBaseCalculation.factor !== undefined && energyBaseCalculation.consumption !== undefined) {
						<div class="flex flex-row justify-between items-start">
							<div>
								{{ t('uviCalc.factor') }}
							</div>
							<div>x {{ numberUtil.scaleAndReplaceDot(energyBaseCalculation.factor, 3) }}</div>
						</div>
						<div class="flex flex-row justify-between items-start">
							<div>
								{{ t('uviPercentage.consumption') }}
							</div>
							<div>
								{{ numberUtil.scaleAndReplaceDot(energyBaseCalculation.consumption, 2) }}
								{{ t('enum.' + (energyBaseCalculation.consumptionUnit ?? 'UNITS')) }}
							</div>
						</div>
					}
				</div>
				@if (costType !== OrdinaryAllocationType.COLDWATER) {
					<div class="p-4">
						<div style="font-weight: bold">
							{{ t('readingValueInfo.conversionConsumption') }}
						</div>
						<div class="flex flex-col">
							<div style="font-size: smaller">
								{{
									formulaUtil.translateFormulaDescription(
										numberUtil.replaceDecimalSymbolByLocale(energyBaseCalculation.consumptionKwhFormula.formulaDescription)
									)
								}}
							</div>
							<div>
								{{ formulaUtil.translateFormula(energyBaseCalculation) }}
							</div>
						</div>
					</div>
				}
			}
		</div>
		<div class="flex flex-row justify-end items-center">
			<button (click)="close()" class="m-2" mat-raised-button name="buttonClose" type="button">
				<mat-icon>cancel</mat-icon>
				<span>
					{{ t('commonActions.close') }}
				</span>
			</button>
		</div>
	</ng-container>
</div>
